var _clipPath;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlbatrosmedia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 232 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard1",
    x: 0,
    y: 0,
    width: 232,
    height: 45.783,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard11",
    x: 0,
    y: 0,
    width: 232,
    height: 45.783
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.513,32.241l-1.916,6.193l3.781,0l-1.865,-6.193Zm-3.134,-5l6.318,0l6.567,17.561l-5.97,0l-0.771,-2.437l-6.119,0l-0.771,2.437l-5.97,0l6.716,-17.561Z",
    style: {
      fill: "#B9012B",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.656,27.217l5.547,0l0,13.158l6.791,0l0,4.427l-12.338,0l0,-17.585Z",
    style: {
      fill: "#B9012B",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.354,30.948l0,2.984l3.06,0c0.522,0 1.816,0 1.816,-1.467c0,-1.443 -1.194,-1.492 -1.692,-1.517l-3.184,0Zm-0.025,6.666l0,3.408l3.483,0c0.497,-0.025 1.02,-0.05 1.443,-0.523c0.273,-0.273 0.447,-0.696 0.447,-1.144c0,-1.642 -1.492,-1.716 -2.015,-1.741l-3.358,0Zm-5.522,-10.373l10.398,0c1.094,0.05 3.134,0.125 4.452,1.418c0.796,0.746 1.194,1.915 1.194,3.035c0,1.293 -0.547,2.388 -1.244,3.084c-0.472,0.473 -0.92,0.672 -1.492,0.945c0.722,0.199 1.368,0.373 2.064,1.07c0.996,0.97 1.17,2.114 1.17,2.985c0,1.318 -0.398,2.686 -1.294,3.582c-1.318,1.343 -3.134,1.392 -4.502,1.442l-10.746,0l0,-17.561Z",
    style: {
      fill: "#B9012B",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.596,32.241l-1.915,6.193l3.781,0l-1.866,-6.193Zm-3.133,-5l6.317,0l6.567,17.561l-5.97,0l-0.771,-2.437l-6.119,0l-0.771,2.437l-5.969,0l6.716,-17.561Z",
    style: {
      fill: "#B9012B",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.288,27.217l14.451,0l0,4.353l-4.452,0l0,13.232l-5.547,0l0,-13.232l-4.452,0l0,-4.353Z",
    style: {
      fill: "#B9012B",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.002,30.898l0,4.104l2.314,0c0.92,0 2.686,-0.05 2.686,-2.04c0,-2.014 -1.741,-2.064 -2.711,-2.064l-2.289,0Zm-5.571,-3.681l8.755,0c1.667,0 3.259,0.099 4.329,0.547c2.338,0.995 3.034,3.383 3.034,5.074c0,0.672 -0.075,2.238 -1.343,3.532c-0.697,0.746 -1.443,1.02 -2.264,1.343l4.278,7.089l-6.168,0l-3.408,-6.193l-1.642,0l0,6.193l-5.571,0l0,-17.585Z",
    style: {
      fill: "#B9012B",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.615,36.022c0,3.059 1.243,4.9 3.88,4.9c2.239,0 3.806,-1.766 3.806,-5.074c0,-0.846 -0.075,-1.617 -0.324,-2.314c-0.845,-2.437 -2.985,-2.512 -3.482,-2.512c-1.99,0 -3.88,1.368 -3.88,5Zm13.282,-0.174c0,4.452 -2.611,9.526 -9.501,9.526c-7.189,0 -9.353,-5.323 -9.353,-9.327c0,-5.025 3.109,-9.452 9.452,-9.452c6.94,0 9.402,5.074 9.402,9.253Z",
    style: {
      fill: "#B9012B",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.698,38.733c0.498,0.771 0.92,1.418 2.438,1.916c0.721,0.248 1.616,0.398 2.462,0.398c0.448,0 2.637,-0.05 2.637,-1.319c0,-0.124 0,-0.771 -0.97,-1.094c-0.622,-0.224 -3.855,-0.796 -4.577,-0.97c-1.617,-0.423 -4.776,-1.418 -4.776,-5.125c0,-0.77 0.175,-1.566 0.498,-2.263c1.144,-2.587 4.104,-3.607 7.263,-3.607c2.015,0 3.855,0.398 5.298,1.12c1.318,0.646 1.965,1.343 2.587,1.989l-3.482,2.911c-0.274,-0.349 -0.572,-0.746 -1.344,-1.144c-1.02,-0.498 -2.363,-0.647 -3.258,-0.647c-0.945,0 -1.99,0.249 -1.99,1.144c0,0.846 0.896,1.07 2.413,1.343c3.905,0.672 7.785,1.368 7.785,5.721c0,1.841 -0.771,3.134 -1.567,3.955c-2.213,2.264 -5.746,2.264 -6.716,2.264c-1.318,0 -2.711,-0.125 -4.079,-0.523c-2.786,-0.796 -4.079,-2.363 -4.875,-3.333l4.253,-2.736Z",
    style: {
      fill: "#B9012B",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.342,27.241l0,17.561l-2.544,0l0.355,-14.725l-6.101,14.725l-1.997,0l-5.992,-14.501l0.273,14.501l-2.517,0l0,-17.561l3.311,0l5.937,14.402l5.964,-14.402l3.311,0Z",
    style: {
      fill: "#B9012B",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.197,36.793l0,5.97l11.163,0l0,2.039l-13.653,0l0,-17.561l13.325,0l0,2.065l-10.835,0l0,5.422l9.412,0l0,2.065l-9.412,0Z",
    style: {
      fill: "#B9012B",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.878,29.306l0,13.482l3.42,0c1.696,-0.025 2.983,-0.05 4.268,-0.722c1.286,-0.647 2.927,-2.238 2.927,-6.019c0,-2.886 -0.93,-5.572 -4.021,-6.443c-1.067,-0.298 -2.189,-0.298 -3.557,-0.298l-3.037,0Zm-2.627,-2.065l6.047,0c2.736,0 5.171,0 7.415,2.164c2.325,2.264 2.407,5.373 2.407,6.617c0,1.219 -0.054,4.651 -2.708,6.915c-2.244,1.865 -4.871,1.865 -6.512,1.865l-6.649,0l0,-17.561Z",
    style: {
      fill: "#B9012B",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.376,
    y: 27.241,
    width: 2.599,
    height: 17.561,
    style: {
      fill: "#B9012B",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.627,37.465l-2.817,-7.313l-2.955,7.313l5.772,0Zm0.767,1.965l-7.36,0l-2.162,5.372l-2.736,0l7.36,-17.561l2.681,0l7.032,17.561l-2.709,0l-2.106,-5.372Z",
    style: {
      fill: "#B9012B",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.67,1.275l30.639,9.553l-30.639,9.552l0,-19.105Z",
    style: {
      fill: "#B9012B"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlbatrosmedia);
export default __webpack_public_path__ + "static/media/albatrosmedia.7cea04404758955eeb7a5c1c0136f4fa.svg";
export { ForwardRef as ReactComponent };